import React from "react";
import { Box, Typography } from "@mui/material";
import dayjs from "dayjs";

const OrderHeader = ({ orderId, createdAt }) => (
  <Box
    display="flex"
    justifyContent="space-between"
    alignItems="center"
    flexWrap="wrap">
    <Typography variant="h6" fontWeight="bold">
      Order #{orderId}
    </Typography>
    <Typography variant="body2" color="text.secondary">
      {createdAt
        ? dayjs(createdAt).format("MMM D, YYYY • h:mm A")
        : "Date Unknown"}
    </Typography>
  </Box>
);

export default OrderHeader;
